$(function () {
  const acc = $('.hs-benefits-right-sdie-content-accordian');
  const bodies = acc.find('.hs-benefits-right-sdie-content-accordian-description-area');

  bodies.hide();                 // Hide all by default
  acc.removeClass('active');     // Remove active class from all

  acc.on('click', '.hs-benefits-right-sdie-content-accordian-title-area', function () {
    const item = $(this).parent();
    const body = item.find('.hs-benefits-right-sdie-content-accordian-description-area');

    if (item.hasClass('active')) {
      item.removeClass('active');
      body.slideUp(200);
    } else {
      acc.removeClass('active');
      bodies.slideUp(200);
      item.addClass('active');
      body.slideDown(200);
    }
  });
});


$(document).ready(function () {
  $(".hs-product-qa-left-side-questioniar-title-block").click(function () {
    
    let parent = $(this).closest(".hs-product-qa-left-side-questioniar");
    let answer = parent.find(".hs-product-qa-left-side-questioniar-answer-block");

    // Close all others
    $(".hs-product-qa-left-side-questioniar-answer-block").not(answer).slideUp();
    $(".hs-product-qa-left-side-questioniar").not(parent).removeClass("active");

    // Toggle current
    answer.slideToggle();
    parent.toggleClass("active");
  });
});

// document.addEventListener('DOMContentLoaded', function() {
//   var recommendation_slider = new Swiper(".hs-product-recommendation-slider", {
    
//     slidesPerView: 4,
//     spaceBetween: 32,

//     navigation: {
//       nextEl: ".hs-product-recommendation-slider-next-btn",
//       prevEl: ".hs-product-recommendation-slider-pre-btn",
//     },

//     breakpoints: {
//       320: {
//         slidesPerView: 1,
//         spaceBetween: 20
//       },
//       576: {
//         slidesPerView: 2,
//         spaceBetween: 20
//       },
//       992: {
//         slidesPerView: 3,
//         spaceBetween: 24
//       },
//       1200: {
//         slidesPerView: 4,
//         spaceBetween: 32
//       }
//     }

//   });
// });

document.addEventListener('DOMContentLoaded', function() {
  var recommendation_slider = new Swiper(".hs-product-recommendation-slider", {
    
    slidesPerView: 3,
    spaceBetween: 60,

    navigation: {
      nextEl: ".hs-product-recommendation-slider-next-btn",
      prevEl: ".hs-product-recommendation-slider-pre-btn",
    },

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      820: {
        slidesPerView: 2,
        spaceBetween: 40
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      1281: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    }

  });
});


document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('product-recommendations:loaded', function() {
    if (window.yotpo && window.yotpo.refreshWidgets) {
      window.yotpo.refreshWidgets();
    }
  });
});


$(document).ready(function() {

  $('.hs-ingredients-right-side-accordian-title-block').click(function () {

    let parent = $(this).closest('.hs-ingredients-right-side-accordian');
    let content = parent.find('.hs-ingredients-right-side-accordian-des-block');

    // Close all others
    $('.hs-ingredients-right-side-accordian-des-block').not(content).slideUp();
    $('.hs-ingredients-right-side-accordian').not(parent).removeClass('active');

    // Toggle current
    parent.toggleClass('active');
    content.stop(true, true).slideToggle();

  });

});


var thumbSwiper = new Swiper(".hs-product-info-slidershow-thumbs-swiper", {
  direction: "vertical",
  spaceBetween: 12,
  slidesPerView: 5,
  freeMode: true,
  watchSlidesProgress: true,
});

var mainSwiper = new Swiper(".hs-product-info-slidershow-main-swiper", {
  spaceBetween: 10,
  observer: true,
  observeParents: true,
  observeSlideChildren: true,
  thumbs: {
    swiper: thumbSwiper,
  },
  navigation: {
    nextEl: ".hs-product-info-main-next",
    prevEl: ".hs-product-info-main-prev",
  }, 

  // Responsive breakpoints
  breakpoints: {
    1281: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    1025: {
      slidesPerView: 2,
    },
    0: {
      slidesPerView: 1, // Default for mobile/tablet
      spaceBetween: 0,
    }
  }
});



document.addEventListener("DOMContentLoaded", () => {

  const qtyBlocks = document.querySelectorAll(".hs-product-info-content-product-quantity-block");

  qtyBlocks.forEach(block => {

    const minusBtn = block.querySelector(".pre-quantity-btn");
    const plusBtn  = block.querySelector(".next-quantity-btn");
    const qtyInput = block.querySelector(".input-quantity");

    if (!qtyInput) return;

    // --- Helper Function: Force Shopify to update immediately ---
    const updateValue = (newVal) => {
      qtyInput.value = newVal;
      qtyInput.setAttribute("value", newVal); // fixes Shopify overwrites
      qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
    };

    // --- Decrease ---
    minusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      let val = parseInt(qtyInput.value) || 1;
      if (val > 1) updateValue(val - 1);
    });

    // --- Increase ---
    plusBtn.addEventListener("click", (e) => {
      e.preventDefault();
      let val = parseInt(qtyInput.value) || 1;
      updateValue(val + 1);
    });

    // --- Prevent negative or zero ---
    qtyInput.addEventListener("input", () => {
      if (qtyInput.value < 1) updateValue(1);
    });

  });
});

// document.addEventListener("DOMContentLoaded", () => {

//   const variantButtons = document.querySelectorAll(".variant-btn");
//   const variantIdInput = document.querySelector(".variant-id");

//   if (!variantIdInput) return;

//   variantButtons.forEach(btn => {
//     btn.addEventListener("click", () => {

//       const variantId = btn.getAttribute("data-variant-id");

//       // Update selected class
//       variantButtons.forEach(b => b.classList.remove("selected"));
//       btn.classList.add("selected");

//       // Update hidden input value for Add to Cart
//       variantIdInput.value = variantId;
//       variantIdInput.setAttribute("value", variantId);

//       // Force Shopify to detect change
//       variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
//     });
//   });

// });

document.addEventListener("DOMContentLoaded", initVariantButtons);

function initVariantButtons() {
  const variantButtons = document.querySelectorAll(".variant-btn");
  const variantIdInput = document.querySelector("input[name='id']");

  if (!variantIdInput || variantButtons.length === 0) return;

  variantButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      const variantId = btn.dataset.variantId;

      variantButtons.forEach(b => b.classList.remove("selected"));
      btn.classList.add("selected");

      variantIdInput.value = variantId;
      variantIdInput.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
}


$(document).ready(function () {

  $(".hs-image-and-text-text-col-accordian-title-block").on("click", function () {

    let parent = $(this).closest(".hs-image-and-text-text-col-accordian");
    let content = parent.find(".hs-image-and-text-text-col-accordian-des-block");

    // Close all other accordions
    $(".hs-image-and-text-text-col-accordian-des-block").not(content).slideUp();
    $(".hs-image-and-text-text-col-accordian").not(parent).removeClass("active");

    // Toggle current one
    content.slideToggle();
    parent.toggleClass("active");
  });

});

document.addEventListener("DOMContentLoaded", () => {
  const tooltipBtn = document.querySelector(".tool-tip");
  const customTooltip = document.querySelector(".custom-tool-tip");

  if (tooltipBtn && customTooltip) {

    // Toggle on button click
    tooltipBtn.addEventListener("click", (e) => {
      e.stopPropagation(); // stop click from reaching document
      customTooltip.classList.toggle("active");
    });

    // Close tooltip when clicking outside
    document.addEventListener("click", (e) => {
      if (!customTooltip.contains(e.target) && !tooltipBtn.contains(e.target)) {
        customTooltip.classList.remove("active");
      }
    });

  }
});


$(document).ready(function() {
    $('.hs-event-sessions-text-accordian-title-block').on('click', function() {
        
        // 1. Identify the parent container of the clicked title
        var $parent = $(this).closest('.hs-event-sessions-text-accordian');
        
        // 2. Identify the description block inside this parent
        var $desc = $parent.find('.hs-event-sessions-text-accordian-desc-block');

        // --- RESET SIBLINGS (Close others) ---
        // Remove 'active' class from all OTHER accordions
        $('.hs-event-sessions-text-accordian').not($parent).removeClass('active');
        // Slide up all OTHER descriptions
        $('.hs-event-sessions-text-accordian').not($parent).find('.hs-event-sessions-text-accordian-desc-block').slideUp();

        // --- TOGGLE CURRENT (Open/Close clicked) ---
        // Toggle the 'active' class on the clicked parent
        $parent.toggleClass('active');
        
        // slideToggle automatically removes 'display: none' when opening
        $desc.slideToggle();
    });
});


$(document).ready(function() {
    $('.hs-ingredients-v2-accordian-title-arrow-block').on('click', function() {
        const $parent = $(this).closest('.hs-ingredients-v2-accordian');
        const $content = $parent.find('.hs-ingredients-v2-accordian-image-text-block');

        // If the clicked item is already open, close it
        if ($parent.hasClass('active')) {
        $content.slideUp();
        $parent.removeClass('active');
        } else {
        // Close all other accordions in this grid
        $('.hs-ingredients-v2-accordian').removeClass('active');
        $('.hs-ingredients-v2-accordian-image-text-block').slideUp();

        // Open the clicked one
        $parent.addClass('active');
        $content.slideDown();
        }
    });
});


  const matchHeight = () => {
    const screenWidth = window.innerWidth;
    const parentBlock = document.querySelector('.hs-seminar-intro-innerblock');
    const imageBlock = document.querySelector('.hs-seminar-intro-image-v2-block');

    if (!parentBlock || !imageBlock) return;

    // Target range: below 1300px AND above 1024px
    if (screenWidth < 1600 && screenWidth > 1024) {
      const parentHeight = parentBlock.offsetHeight;
      imageBlock.style.height = parentHeight + 'px';
      
      // Ensure the image inside fills the height properly
      const img = imageBlock.querySelector('img');
      if(img) {
        img.style.height = '100%';
        img.style.objectFit = 'cover';
      }
    } else {
      // Reset height if outside the target screen range
      imageBlock.style.height = 'auto';
    }
  };

const matchHeightv2 = () => {
    const screenWidth = window.innerWidth;
    const parentBlock = document.querySelector('.hs-seminar-intro-innerblock');
    const imageBlock = document.querySelector('.hs-seminar-intro-image-block');

    if (!parentBlock || !imageBlock) return;

    // Target range: below 1300px AND above 1024px
    if (screenWidth < 1400 && screenWidth > 1024) {
      const parentHeight = parentBlock.offsetHeight;
      imageBlock.style.height = parentHeight + 'px';
      
      // Ensure the image inside fills the height properly
      const img = imageBlock.querySelector('img');
      if(img) {
        img.style.height = '100%';
        img.style.objectFit = 'cover';
      }
    } else {
      // Reset height if outside the target screen range
      imageBlock.style.height = 'auto';
    }
  };

  // Run on load
  window.addEventListener('load', matchHeight,matchHeightv2);
  // Run on resize
  window.addEventListener('resize', matchHeight,matchHeightv2);

